import { createContext } from 'react';
import { GeneralListResponse } from '../../types';
import { ListFormContextProps, ListReducerState } from './types';
import { LIST_SIDEBAR_FILTER_FORM_NAME } from '../../components/ListSidebar/const';

export const ListAPIContext = createContext(null as unknown);
export const ListContext = createContext(null as unknown);
export const ListCommonContext = createContext(null as unknown);
export const ListFormContext = createContext<ListFormContextProps | null>(null);

export const ListProviderDataKey = 'FILTER_LIST_PROVIDER';
export const LIST_PLACEHOLDER_DATA: GeneralListResponse = {
	accesses: {},
	actions: [],
	appliedFiltersCount: 0,
	columns: [],
	filter: {
		values: {},
		metadata: {},
	},
	filterBreadcrumb: [],
	listItems: [],
	listItemsCount: '',
	page: { title: '' },
};

export const DEFAULT_REDUCER_VALUE: ListReducerState = {
	data: LIST_PLACEHOLDER_DATA,
	canFetchMore: false,
	isFetched: false,
	isAvailable: false,
	isLoading: true,
	error: null,
	hasInitialData: false,
	lastFilterSubmitTime: new Date(),
	lastFilterComponentFetchedTime: {},
	defaultTake: 30,
	formName: LIST_SIDEBAR_FILTER_FORM_NAME,
	sanitizedFilterValues: {},
	isFilterSubmitted: false,
	isPaginationSubmitted: false,
};

export enum ListReducerAction {
	START_FETCHING,
	TOGGLE_AVAILABILITY,
	RESET_SAVED_FILTER_STATE,
	ACTIVATE_SAVED_FILTER,
	SET_ERROR,
	SET_RESPONSE,
	SET_LAST_FILTER_COMPONENT_FETCHED_TIME,
	SET_INITIAL_DATA,
	APPEND_LIST_ITEMS,
	SET_TEMP_COLUMNS,
	SET_ITEMS_LIST_COUNT,
	SET_RESPONSE_FILTER_DATA,
	SET_LIST,
}

export const PERSISTED_LIST_RESPONSE_ITEMS_COUNT = 13;
export const SYNC_MANAGER_UPDATE_API_EVENT = 'SYNC_MANAGER_UPDATE_API_EVENT_';
export const SYNC_MANAGER_INIT_API_EVENT = 'SYNC_MANAGER_INIT_API_EVENT_';
export const STORAGE_PARTIAL_KEY = 'ListProvider';
export const IS_LIST_PAGE_KEY = 'is_list_page';
export const SYNC_MANAGER_START_SUBMITTING_EVENT = 'SYNC_MANAGER_START_SUBMITTING_EVENT';
export const SYNC_MANAGER_FINISH_SUBMITTING_EVENT = 'SYNC_MANAGER_FINISH_SUBMITTING_EVENT';
